export enum SearchTopCategory {
  EVENTS = 'events',
  INNOVATION_ZONE = 'innovation_zone',
  AWARDS = 'awards',
  TRENDS = 'trends'
}

export type SubCategoryValue = {
  value: string;
  label: string;
  filter: string;
  extra?: string;
  context?: string;
};

export const SUBCATEGORIES: {
  [categoryKey: string]: SubCategoryValue[];
} = {
  events: [
    {
      value: 'global_2025',
      label: 'Global 2025',
      filter: 'events'
    },
    {
      value: 'asia_2024',
      label: 'Asia 2024',
      filter: 'events'
    },
    {
      value: 'latam_2024',
      label: 'Latam 2024',
      filter: 'events'
    },
    {
      value: 'global_2024',
      label: 'Global 2024',
      filter: 'events'
    },
    {
      value: 'asia_2023',
      label: 'Asia 2023',
      filter: 'events'
    },
    {
      value: 'global_2023',
      label: 'Global 2023',
      filter: 'events'
    }
  ],
  innovation_zone: [
    {
      value: '2025',
      label: '2025',
      filter: 'award_year'
    },
    {
      value: '2024',
      label: '2024',
      filter: 'award_year'
    },
    {
      value: '2023',
      label: '2023',
      filter: 'award_year',
      extra: 'separator'
    },
    {
      value: 'innovation-zone',
      label: 'Innovation Zone',
      filter: 'award_category_key'
    },
    {
      value: 'sustainability-zone',
      label: 'Sustainability Zone',
      filter: 'award_category_key'
    }
  ],
  awards: [
    {
      value: '2025',
      label: '2025',
      filter: 'award_year',
      context: 'award'
    },
    {
      value: '2024',
      label: '2024',
      filter: 'award_year',
      context: 'award'
    },
    {
      value: '2023',
      label: '2023',
      filter: 'award_year',
      context: 'award'
    },
    {
      value: 'innovation-zone-active',
      label: 'Active',
      filter: 'award_category_key',
      context: 'award'
    },
    {
      value: 'innovation-zone-functional',
      label: 'Functional',
      filter: 'award_category_key',
      context: 'award'
    },
    {
      value: 'green-ingredient',
      label: 'Green',
      filter: 'award_category_key',
      context: 'award'
    },
    {
      value: 'kenvue-trusted-science-award',
      label: 'Kenvue',
      filter: 'award_category_key',
      context: 'award'
    }
  ],
  trends: [
    {
      value: 'Neurocosmetics',
      label: 'Neurocosmetics',
      filter: 'trends'
    },
    {
      value: 'Microbiome',
      label: 'Microbiome',
      filter: 'trends'
    },
    {
      value: 'Marine',
      label: 'Marine',
      filter: 'trends'
    },
    {
      value: 'Biotech',
      label: 'Biotech',
      filter: 'trends'
    },
    {
      value: 'Well-being',
      label: 'Well-being',
      filter: 'trends'
    },
    {
      value: 'Skinification',
      label: 'Skinification',
      filter: 'trends'
    },
    {
      value: 'Waterless',
      label: 'Waterless',
      filter: 'trends'
    },
    {
      value: 'Dermocosmetics',
      label: 'Dermocosmetics',
      filter: 'trends'
    },
    {
      value: 'Skin Barrier',
      label: 'Barrier Support',
      filter: 'trends'
    }
  ]
};
